import React from 'react'
import IdleTimer from 'react-idle-timer'
import * as saveAction from './../action/save'
import {tempSCData,getProductObject} from './../service/dtmTag'

export default class Timer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.onIdle = this._onIdle.bind(this)
  }

  _onIdle() {
    tempSCData.product = getProductObject(this.props.orderDetail, this.props.tierPricing);
    if( this.props.monNo !== undefined  && this.props.monNo !== null && this.props.monNo !== '' && !this.props.buildProductState?.isACPFlag && !this.props.buildProductState?.isVZFwdFlag){
      saveAction.smartSave(this.props.dispatch, this.props.visitId, "passive", (this.props.credit.creditCheckResponse !== null) ? true : false, false,null, null, false, this.props.isFCPflow, this.props.isDoFlow, this.props.buildProductState);
    }
  }

  render() {
    return (
      <React.Fragment>
        <IdleTimer
          onIdle={this.onIdle}
          timeout={60000} />
      </React.Fragment>
    )
  }

}